export default __webpack_public_path__ + "static/media/A1_3.0c70f694.mp3";